"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listProductsQuerySchema = exports.updateProductSchema = exports.createProductSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const enums_1 = require("../enums");
const common_schema_1 = require("./common.schema");
const VAT_CATEGORY_VALUES = Object.values(enums_1.VatCategory);
// Bare (undefaulted) field definitions, shared by create and update — same
// reasoning as firm.schema.ts's `firmFields` / series.schema.ts's
// `seriesFields`: zod's `.default()` fires on ANY `undefined` input, even a
// field simply absent from a PATCH body, even after `.partial()`. Applying
// `.default()` here and reusing this object for `updateProductSchema.partial()`
// would mean a PATCH `{unitPrice: "150.00"}` alone silently resets unitCode/
// vatCategory/currency/isActive back to their create-time defaults on every
// update. Defaults are therefore only layered on in `createProductSchema`
// below, never on the shape update reuses.
const productFields = {
    companyId: zod_1.z.uuid('companyId invalid.'),
    name: zod_1.z.string().trim().min(1, 'Numele este obligatoriu.'),
    description: zod_1.z.string().trim().optional(),
    unitCode: zod_1.z.enum(constants_1.UNIT_CODE_VALUES, 'Unitate de măsură invalidă.'),
    // `unitLabel` is optional here — when omitted, the service fills it in
    // server-side from UNIT_CODES based on `unitCode`; a client may still send
    // its own label to override the default.
    unitLabel: zod_1.z.string().trim().min(1).optional(),
    unitPrice: zod_1.z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,2})?$/, 'Prețul trebuie să fie un număr pozitiv cu cel mult 2 zecimale.'),
    vatCategory: zod_1.z.enum(VAT_CATEGORY_VALUES, 'Categorie TVA invalidă.'),
    currency: zod_1.z.string().trim().length(3, 'Moneda trebuie să aibă 3 caractere.'),
    isActive: zod_1.z.boolean(),
};
exports.createProductSchema = zod_1.z.object({
    ...productFields,
    unitCode: productFields.unitCode.default('H87'),
    vatCategory: productFields.vatCategory.default(enums_1.VatCategory.STANDARD),
    currency: productFields.currency.default('RON'),
    isActive: productFields.isActive.default(true),
});
// Built from the undefaulted `productFields` (see comment above) so an
// omitted field stays truly absent instead of reappearing as its
// create-time default.
exports.updateProductSchema = zod_1.z.object(productFields).omit({ companyId: true }).partial();
exports.listProductsQuerySchema = common_schema_1.paginationQuerySchema.extend({
    companyId: zod_1.z.uuid('companyId este obligatoriu și trebuie să fie un UUID valid.'),
});
